import React, { Suspense, lazy } from "react";
import { useRoutes } from "react-router-dom";
import Loader from "../layout/loader";
import { appRoutes } from "../constant";
import PrivateRoutes from "../utilities/PrivateRoutes";
import KYCBackup from "../components/documents/kyc/kycBackup";
import AssignedProductsToClient from "../components/affiliations/clients/companies/assigned-products";
import AssignedDealershipsToClient from "../components/affiliations/clients/partnerships/assigned-dealerships";
import AdminWalletHistory from "../components/wallet/admin-wallet";
import EAWalletHistory from "../components/wallet/ea-wallet";
import { getFromLocalStorage } from "../hooks/useLocalStorage.js";
import AccessDenied from "../components/common/AccessDenied.jsx";
import TravelCareStepper from "../pages/scanme/scanMe.jsx";
import GetInTouch from "../pages/scanme/GetInTouch.jsx";
import ComingSoon from "../pages/scanme/ComingSoon.jsx";
import ServiceDetails from "../pages/scanme/serviceDetails.jsx";
import Salutation from "../components/masters/salutation/Salutation.jsx";
import TermsAndConditions from "../pages/scanme/termAndConditions.jsx";
import creditNote from "../components/affiliations/clients/CN/credit-note.jsx";
import CreditNoteCertificateWithLocalizationProvider from "../components/affiliations/clients/CN/credit-note.jsx";
import ViewQuotation from "../pages/sendQuotation/view-quotation.jsx";
import ViewQuotationStepper from "../pages/sendQuotation/viewQuotationStepper.jsx";
import BPCreditNoteListing from "../components/affiliations/clients/CN/bp-credit-note.jsx";
import BulkDocument from "../components/sales/policies/bulk-documents/bulk-document-type-and-scheme.jsx";
import BulkUploadSample from "../components/sales/policies/bulk-documents/bulk-upload-sample.jsx";
import BulkDocumentSuccessPage from "../components/sales/policies/bulk-documents/BulkDocumentSuccessPage.jsx";
import BulkProposerDetaillsPage from "../components/sales/policies/bulk-documents/BulkProposerDetaillsPage.jsx";
import BulkPaymentDetailsPage from "../components/sales/policies/bulk-documents/BulkPaymentDetailsPage.jsx";
import RoleReassignment from "../components/affiliations/clients/partnerships/role-reassignment/role-reassignment.jsx";
import FeatureManagement from "../components/affiliations/clients/features/FeatureManagement.jsx";
import BulkInvoiceWalletWithLocalizationProvider from "../components/sales/policies/bulk-documents/invoices/bulk-invoice-wallet.jsx";
import BulkInvoiceCutnpayWithLocalizationProvider from "../components/sales/policies/bulk-documents/invoices/bulk-cutnpay.jsx";
import MscBulkClaimCpgPage from "../components/sales/policies/bulk-documents/MscBulkClaimCpgPage.jsx";
import ReconcileReport from "../components/reports/reconcile/ReconcileReport.jsx";
import PremiumCalculator from "../components/sales/policies/premium-calculator/premium_calculator.jsx";
import MscLedger from "../components/ledger/mscLedger/mscLedger.jsx";
import InvoiceLedger from "../components/ledger/invoiceLedger/invoiceLedger.jsx";
import BpGstVerification from "../components/bpGstVerification/bpGstVerification.jsx";
import BpGstVerificationReport from "../components/reports/bp-gst-verification/BpGstVerificationReport.jsx";
// import CashifyRequestsForMe from "../components/requests/cashify-my-request.jsx";



function checkRoleAccess(allowedRoles, component) {
  const ROLE = getFromLocalStorage("ROLE")?.key;
  if (allowedRoles?.includes(ROLE)) {
    return component;
  } else {
    return <AccessDenied />; 
  }
}
// eslint-disable-next-line react/display-name
const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
function ApplicationRoutes() {
  return useRoutes([
    {
      path: "",
      children: [
        { path: appRoutes.LOGIN, element: <Signin /> },
        { path: appRoutes.REMEMBER_ME, element: <RememberMe /> },
        { path: appRoutes.AUTH_LOGIN, element: <Login /> },
        { path: appRoutes.CALLBACK_LOGIN, element: <CallBackLogin /> },
        
        { path: appRoutes.SCANME_LANDING, element: <TravelCareStepper /> },
        { path: appRoutes.QUOTATION, element: <ViewQuotationStepper /> },
        // { path: appRoutes.SCANME_LANDING, element: <ComingSoon /> },
        { path: appRoutes.GET_IN_TOUCH, element: <GetInTouch/> },
        {path: appRoutes.GET_SERVICE_DETAILS, element: <ServiceDetails/>},
        {path: appRoutes.TERMS_AND_CONDITIONS, element: <TermsAndConditions/>},
        {path: appRoutes.GET_USER, element: <ServiceDetails/>},
        {
          path: appRoutes.AUTH_LOGIN_LOGIN_WITH_IMG1,
          element: <LoginWithBgImage />,
        },
        {
          path: appRoutes.AUTH_LOGIN_LOGIN_WITH_IMG2,
          element: <LoginWithBgVideo />,
        },
        {
          path: appRoutes.AUTH_LOGIN_WITH_VALIDATION,
          element: <LoginWithValidation />,
        },
        { path: appRoutes.AUTH_SIGNUP, element: <Register /> },
        {
          path: appRoutes.AUTH_SIGNUP_WITH_IMG1,
          element: <RegisterWithBgImage />,
        },
        {
          path: appRoutes.AUTH_SIGNUP_WITH_IMG2,
          element: <RegisterWithBgVideo />,
        },
        { path: appRoutes.AUTH_FORGOT_PASSWORD, element: <Forgetpwd /> },
        { path: appRoutes.AUTH_UNLOCK_USER, element: <UnlockUser /> },
        { path: appRoutes.AUTH_RESET_PASSWORD, element: <Resetpwd /> },
        { path: appRoutes.ERRORS_ERROR400, element: <Error400 /> },
        { path: appRoutes.ERRORS_ERROR401, element: <Error401 /> },
        { path: appRoutes.ERRORS_ERROR403, element: <Error403 /> },
        { path: appRoutes.ERRORS_ERROR404, element: <Error404 /> },
        { path: appRoutes.ERRORS_ERROR500, element: <Error500 /> },
        { path: appRoutes.ERRORS_ERROR503, element: <Error503 /> },
        { path: appRoutes.COMMING_SOON, element: <Comingsoon /> },
        { path: appRoutes.COMMING_SOON_IMG, element: <ComingsoonImg /> },
        { path: appRoutes.COMMING_SOON_VIDEO, element: <ComingsoonVideo /> },
        { path: appRoutes.MAINTAINANCE, element: <Maintenance /> },
        { path: appRoutes.CALLBACK, element: <Callback /> },
        { path: appRoutes.FORGOT_PASSWORD, element: <ForgotPassword /> },
        { path: appRoutes.OTP, element: <ValidateOTP /> },
        { path: appRoutes.MAIL_SENT, element: <MailSent /> },
        { path: appRoutes.RESET_PASSWORD, element: <ResetPassword /> },
        {
          path: appRoutes.USER_FIRST_TIME_LOGIN,
          element: <FirstLoginValidateOTP />,
        },
        { path: appRoutes.ALLOCATION, element: <Allocation /> },
        { path: appRoutes.HIERARCHY, element: <Hierarchy /> },
        { path: appRoutes.TARGET_ALLOTMENT, element: <TargetAlloment /> },
        { path: appRoutes.TARGET_PAGE, element: <TargetPage /> },
        {
          path: appRoutes.TEAM_MEMBER_DASHBOARD,
          element: <TeamMemberDashboard />,
        },
        
        { path: appRoutes.DEALER_DASHBOARD, element: <DealerDashboard /> },
        { path: appRoutes.CCM_DASHBOARD, element: <CcmDashboard /> },
        { path: appRoutes.DSP_DASHBOARD, element: <DspDashboard /> },
        { path: appRoutes.FINANCE_DASHBOARD, element: <FinanceDasbaord /> },
        { path: appRoutes.HOME, element: <Home /> },
        { path: appRoutes.VEHICLE_DETAILS, element: <vehicleDetails /> },
        {
          path: appRoutes.VEHICLE_DETAILS_INOVICE,
          element: <vehicleDetailsInvoice />,
        },
      ],
    },
    {
      path: "",
      element: <PrivateRoutes />,
      children: [{ path: appRoutes.ROLE, element: <SelectUserRole /> }],
    },
    {
      path: "",
      element: <PrivateRoutes />,
      children: [
        {
          path: appRoutes.SALE_CATEGORY,
          element: <App Component={<SaleCategory />} />,
        },
        {
          path: "dashboard/default",
          element: <App Component={<Default />} />,
        },
        {
          path: "dashboard/default/",
          element: <App Component={<RolesSelection />} />,
        },
        {
          path: "dashboard/ecommerce/:layout/",
          element: <App Component={<Ecommerce />} />,
        },
        {
          path: "widgets/general/:layout",
          element: <App Component={<GeneralWidget />} />,
        },
        {
          path: "widgets/chart/:layout",
          element: <App Component={<ChartsWidget />} />,
        },
        {
          path: "ui-kits/statecolor/:layout",
          element: <App Component={<StateColor />} />,
        },
        {
          path: "ui-kits/typography/:layout",
          element: <App Component={<Typography />} />,
        },
        {
          path: "ui-kits/avatar/:layout",
          element: <App Component={<Avatars />} />,
        },
        {
          path: "ui-kits/helperclass/:layout",
          element: <App Component={<HelperClasses />} />,
        },
        { path: "ui-kits/grid/:layout", element: <App Component={<Grid />} /> },
        {
          path: "ui-kits/tagsandpills/:layout",
          element: <App Component={<TagAndPills />} />,
        },
        {
          path: "ui-kits/progress-bar/:layout",
          element: <App Component={<Progress />} />,
        },
        {
          path: "ui-kits/modal/:layout",
          element: <App Component={<Modal />} />,
        },
        {
          path: "ui-kits/alert/:layout",
          element: <App Component={<Alert />} />,
        },
        {
          path: "ui-kits/popover/:layout",
          element: <App Component={<Popover />} />,
        },
        {
          path: "ui-kits/tooltips/:layout",
          element: <App Component={<Tooltip />} />,
        },
        {
          path: "ui-kits/spinner/:layout",
          element: <App Component={<Spinner />} />,
        },
        {
          path: "ui-kits/dropdown/:layout",
          element: <App Component={<Dropdown />} />,
        },
        {
          path: "ui-kits/tab-bootstrap/:layout",
          element: <App Component={<TabBootstrap />} />,
        },
        {
          path: "ui-kits/tab-line/:layout",
          element: <App Component={<TabLine />} />,
        },
        {
          path: "ui-kits/accordion/:layout",
          element: <App Component={<Accordian />} />,
        },
        {
          path: "ui-kits/shadow/:layout",
          element: <App Component={<Shadow />} />,
        },
        { path: "ui-kits/list/:layout", element: <App Component={<List />} /> },
        {
          path: "bonus-ui/scrollable/:layout",
          element: <App Component={<Scrolling />} />,
        },
        {
          path: "bonus-ui/bootstrap-notify/:layout",
          element: <App Component={<BootstrapNotify />} />,
        },
        {
          path: "bonus-ui/rating/:layout",
          element: <App Component={<Rating />} />,
        },
        {
          path: "bonus-ui/dropzone/:layout",
          element: <App Component={<Dropzone />} />,
        },
        {
          path: "bonus-ui/sweetAlert/:layout",
          element: <App Component={<SweetAlert />} />,
        },
        {
          path: "bonus-ui/tourComponent/:layout",
          element: <App Component={<Tour />} />,
        },
        {
          path: "bonus-ui/stickyNotes/:layout",
          element: <App Component={<Sticky />} />,
        },
        {
          path: "bonus-ui/breadcrumb/:layout",
          element: <App Component={<Breadcrumb />} />,
        },
        {
          path: "bonus-ui/imageCropper/:layout",
          element: <App Component={<Imagecrop />} />,
        },
        {
          path: "bonus-ui/rangeSlider/:layout",
          element: <App Component={<RangeSlider />} />,
        },
        {
          path: "bonus-ui/carousel/:layout",
          element: <App Component={<Carousel />} />,
        },
        {
          path: "bonus-ui/ribbons/:layout",
          element: <App Component={<Ribbons />} />,
        },
        {
          path: "bonus-ui/pagination/:layout",
          element: <App Component={<Pagination />} />,
        },
        {
          path: "bonus-ui/dragNDropComp/:layout",
          element: <App Component={<DragAndDrop />} />,
        },
        {
          path: "bonus-ui/image-upload/:layout",
          element: <App Component={<UploadImage />} />,
        },
        {
          path: "bonus-ui/card/basicCards/:layout",
          element: <App Component={<BasicCards />} />,
        },
        {
          path: "bonus-ui/card/creativeCards/:layout",
          element: <App Component={<ThemeCards />} />,
        },
        {
          path: "bonus-ui/card/tabCard/:layout",
          element: <App Component={<TabCard />} />,
        },
        {
          path: "bonus-ui/card/draggingCards/:layout",
          element: <App Component={<DraggingCards />} />,
        },

        {
          path: "bonus-ui/timelines/timeline1/:layout",
          element: <App Component={<Timeline1 />} />,
        },

        {
          path: "icons/flagIcons/:layout",
          element: <App Component={<FlagIcons />} />,
        },
        {
          path: "icons/fontAwsomeIcon/:layout",
          element: <App Component={<FontAwsomeIcon />} />,
        },
        {
          path: "icons/icoIcons/:layout",
          element: <App Component={<IcoIcons />} />,
        },
        {
          path: "icons/featherIcons/:layout",
          element: <App Component={<FeatherIcons />} />,
        },
        {
          path: "icons/themifyIcons/:layout",
          element: <App Component={<ThemifyIcons />} />,
        },
        {
          path: "icons/weatherIcons/:layout",
          element: <App Component={<WeatherIcons />} />,
        },
        {
          path: "buttons/default-btn/:layout",
          element: <App Component={<DefaultButton />} />,
        },
        {
          path: "buttons/flatBtn/:layout",
          element: <App Component={<FlatButton />} />,
        },
        {
          path: "buttons/edgeBtn/:layout",
          element: <App Component={<EdgeButton />} />,
        },
        {
          path: "buttons/raisedBtn/:layout",
          element: <App Component={<RaisedButton />} />,
        },
        {
          path: "buttons/groupBtn/:layout",
          element: <App Component={<GroupButton />} />,
        },
        {
          path: "forms/form-validation/:layout",
          element: <App Component={<FormValidation />} />,
        },
        {
          path: "affiliate/client/companies/test",
          element: <App Component={<AffiliationCompaniesTest />} />,
        },
        {
          path: "forms/baseInput/:layout",
          element: <App Component={<BaseInput />} />,
        },
        {
          path: "forms/inputGroup/:layout",
          element: <App Component={<InputGroup />} />,
        },
        {
          path: "forms/megaOptions/:layout",
          element: <App Component={<MegaOption />} />,
        },
        {
          path: "forms/radio-checkbox/:layout",
          element: <App Component={<CheckboxandRadio />} />,
        },
        {
          path: "form-layout/formDefault/:layout",
          element: <App Component={<FormDefault />} />,
        },
        {
          path: "form-layout/formWizard/:layout",
          element: <App Component={<FormWizard1 />} />,
        },

        {
          path: "form-widget/datepicker",
          element: <App Component={<Datepicker />} />,
        },
        {
          path: "form-widget/timepicker/:layout",
          element: <App Component={<Timepicker />} />,
        },
        {
          path: "form-widget/typeahead/:layout",
          element: <App Component={<Typeahead />} />,
        },

        {
          path: "table/basic/:layout",
          element: <App Component={<BasicTabels />} />,
        },
        {
          path: "table/border/:layout",
          element: <App Component={<BorderTable />} />,
        },
        {
          path: "table/sizing/:layout",
          element: <App Component={<SizingTable />} />,
        },
        {
          path: "table/styling/:layout",
          element: <App Component={<StylingTable />} />,
        },
        {
          path: "table/datatable/:layout",
          element: <App Component={<DataTable />} />,
        },

        {
          path: "charts/apexCharts/:layout",
          element: <App Component={<Apexcharts />} />,
        },
        {
          path: "charts/googleChart/:layout",
          element: <App Component={<GoogleCharts />} />,
        },
        {
          path: "charts/knobChart/:layout",
          element: <App Component={<KnobChart />} />,
        },
        {
          path: "charts/chartistComponent/:layout",
          element: <App Component={<Chartist />} />,
        },

        {
          path: "app/gallery/imageGallery/:layout",
          element: <App Component={<ImageGallery />} />,
        },
        {
          path: "app/gallery/imageWithDesc/:layout",
          element: <App Component={<ImageWithDesc />} />,
        },
        {
          path: "app/gallery/mesonryGallery/:layout",
          element: <App Component={<MesonryGallery />} />,
        },
        {
          path: "app/gallery/mesonryDesc/:layout",
          element: <App Component={<MesonryDesc />} />,
        },
        {
          path: "app/gallery/imageHover/:layout",
          element: <App Component={<ImageHover />} />,
        },

        {
          path: "app/blog/blogDetail/:layout",
          element: <App Component={<BlogDetail />} />,
        },
        {
          path: "app/blog/blogSingle/:layout",
          element: <App Component={<BlogSingle />} />,
        },
        {
          path: "app/blog/blogPost/:layout",
          element: <App Component={<BlogPost />} />,
        },

        {
          path: "app/jobSearch/cardView/:layout",
          element: <App Component={<CardView />} />,
        },
        {
          path: "app/jobSearch/job-list/:layout",
          element: <App Component={<JobList />} />,
        },
        {
          path: "app/jobSearch/job-detail/:layout",
          element: <App Component={<JobDetail />} />,
        },
        {
          path: "app/jobSearch/job-apply/:layout",
          element: <App Component={<JobApply />} />,
        },

        {
          path: "app/learning/learning-list/:layout",
          element: <App Component={<Learninglist />} />,
        },
        {
          path: "app/learning/learning-detail/:layout",
          element: <App Component={<LearningDeatil />} />,
        },

        {
          path: "app/users/userProfile/:layout",
          element: <App Component={<UserProfile />} />,
        },
        {
          path: "app/users/userEdit/:layout",
          element: <App Component={<UserEdit />} />,
        },
        {
          path: "app/users/userCards/:layout",
          element: <App Component={<UserCards />} />,
        },
        {
          path: "app/calendar/basic-calendar/:layout",
          element: <App Component={<BasicCalender />} />,
        },
        {
          path: "app/calendar/draggable-calendar/:layout",
          element: <App Component={<DraggableCalendar />} />,
        },

        {
          path: "app/map/googleMap/:layout",
          element: <App Component={<GoogleMap />} />,
        },

        {
          path: "app/editor/ckEditor/:layout",
          element: <App Component={<CkEditor />} />,
        },
        {
          path: "app/editor/mdeEditor/:layout",
          element: <App Component={<MdeEditor />} />,
        },

        {
          path: "app/social-app/:layout",
          element: <App Component={<SocialApp />} />,
        },
        {
          path: "app/faq/:layout",
          element: <App Component={<FaqComponent />} />,
        },
        {
          path: "app/knowledgebase/:layout",
          element: <App Component={<KnowledgebaseComponent />} />,
        },
        {
          path: "app/support-ticket/:layout",
          element: <App Component={<SupportTicket />} />,
        },

        {
          path: "pages/samplepage/:layout",
          element: <App Component={<Sample />} />,
        },
        {
          path: "playground",
          element: <App Component={<Playground />} />,
        },
        {
          path: "mis_cron",
          element: <App Component={<MisReports />} />,
        },
        {
          path: "pages/searchpage/:layout",
          element: <App Component={<Search />} />,
        },

        {
          path: "app/ecommerce/product/:layout",
          element: <App Component={<Product />} />,
        },
        {
          path: "app/ecommerce/product-page/:id/:layout",
          element: <App Component={<ProductDetail />} />,
        },
        {
          path: "app/ecommerce/cart/:layout",
          element: <App Component={<Cart />} />,
        },
        {
          path: "app/ecommerce/wishlist/:layout",
          element: <App Component={<Wishlist />} />,
        },
        {
          path: "app/ecommerce/checkout/:layout",
          element: <App Component={<Checkout />} />,
        },
        // {
        //   path: "app/ecommerce/invoice/:layout",
        //   element: <App Component={<Invoice />} />,
        // },
        {
          path: "app/ecommerce/product-list/:layout",
          element: <App Component={<Productlist />} />,
        },
        {
          path: "app/ecommerce/payment-details/:layout",
          element: <App Component={<Paymentdetails />} />,
        },
        {
          path: "app/ecommerce/orderhistory/:layout",
          element: <App Component={<OrderHistory />} />,
        },
        {
          path: "app/ecommerce/pricing/:layout",
          element: <App Component={<Pricing />} />,
        },

        {
          path: "app/email-app/:layout",
          element: <App Component={<Email />} />,
        },
        { path: "app/chat-app/:layout", element: <App Component={<Chat />} /> },
        {
          path: "app/bookmark/:layout",
          element: <App Component={<Bookmark />} />,
        },
        { path: "app/task/:layout", element: <App Component={<TaskApp />} /> },

        {
          path: "app/project/project-list/:layout",
          element: <App Component={<ProjectList />} />,
        },
        {
          path: "app/project/new-project/:layout",
          element: <App Component={<NewProject />} />,
        },

        {
          path: "app/file-manager/:layout",
          element: <App Component={<FileManager />} />,
        },
        {
          path: "app/kanban-board/:layout",
          element: <App Component={<kanbanBoard />} />,
        },

        {
          path: "app/contact/:layout",
          element: <App Component={<ContactApp />} />,
        },

        {
          path: "app/todo-app/todo/:layout",
          element: <App Component={<Todo />} />,
        },
        {
          path: "app/todo-app/todo-firebase/:layout",
          element: <App Component={<TodoFirebase />} />,
        },
        {
          path: "wallet/statement",
          element: <App Component={<UserWalletStatement />} />,
        },
        {
          path: appRoutes.SALE_CATEGORY,
          element: <App Component={<SaleCategory />} />,
        },
        { path: "sales/products", element: <App Component={<Products />} /> },
        { path: "sales/cashifyproducts", element: <App Component={<Cashifyproducts/>} /> },
        { path: "sales/services", element: <App Component={<Services />} /> },
        { path: "sales/coupons", element: <App Component={<Coupons />} /> },
        { path: "sales/policies", element: <App Component={<Policies />} /> },
        {
          path: "sales/policies/certificate",
          element: <App Component={<Certificate />} />,
        },
         {
          path: "sales/policies/add-document",
          element: <App Component={<AddDocument />} />,
        },
         {
          path: "ledger/invoice",
          element: <App Component={<InvoiceLedger />} />,
        },
         {
          path: "ledger/msc",
          element: <App Component={<MscLedger />} />,
        },
        {
          path: 'components/bpGstVerification',
          element: <App Component={<BpGstVerification />} />,
        },
        {
          path: "sales/policies/nyom",
          element: <App Component={<NyomPolicies />} />,
        },
        {
          path: "sales/policies/quotation",
          element: <App Component={<Quotation />} />,
        },
        {
          path: "sales/policies/dashboard-sync",
          element: <App Component={<SyncDashboard />} />,
        },
        {
          path: "sales/policies/invoice",
          element: <App Component={<Invoice />} />,
        },
        {
          path: "sales/policies/invoice-normal-wallet",
          element: <App Component={<InvoiceNormalWallet />} />,
        },
        {
          path: "sales/policies/customer-invoice-payment",
          element: <App Component={<CsutomerPaymentInvoice />} />,
        },
        {
          path: "sales/policies/certificate2",
          element: <App Component={<Certificate2 />} />,
        },
        {
          path: "sales/commission/commission",
          element: <App Component={<Commission />} />,
        },
         {
          path: "sales/commission/partnership-commission",
          element: <App Component={<BPCreditNoteListing />} />,
        },
        {
          path: "sales/certificates/search-certificate",
          element: <App Component={<SearchCertificates />} />,
        },
        {
          path: "sales/policies/customer",
          element: <App Component={<Customers />} />,
        },
        {
          path: "masters/types",
          element: <App Component={<Types />} />,
        },
        {
          path: "masters/city",
          element: <App Component={<City />} />,
        },
        {
          path: "masters/assistance",
          element: <App Component={<Assistance />} />,
        },
        {
          path: "masters/zone",
          element: <App Component={<Zone />} />,
        },
        {
          path: "masters/pincode",
          element: <App Component={<Pincode />} />,
        },
        {
          path: "masters/ins_pincode",
          element: <App Component={<InsPincode />} />,
        },
        {
          path: "masters/cancellation_reasons",
          element: <App Component={<CancellationReasons />} />,
        },
        {
          path: "masters/categories",
          element: <App Component={<Category />} />,
        },
        {
          path: "masters/servicetype",
          element: <App Component={<ServiceType />} />,
        },
        {
          path: "masters/country",
          element: <App Component={<Country />} />,
        },
        {
          path: "masters/geographical_cover",
          element: <App Component={<Geographical_Cover />} />,
        },
        {
          path: "masters/service",
          element: <App Component={<Service />} />,
        },
        {
          path: "masters/main-services",
          element: <App Component={<MainService />} />,
        },
        {
          path: "masters/companyhastypes",
          element: <App Component={<CompanyTypes />} />,
        },
        {
          path: "masters/companyhastypeshasgeo",
          element: <App Component={<CompanyTypesGeo />} />,
        },
        {
          path: "masters/bulk-upload-sample",
          element: <App Component={<BulkUploadSample />} />,
        },
        {
          path: "masters/gender",
          element: <App Component={<Gender />} />,
        },
        {
          path: "masters/nomineerelation",
          element: <App Component={<NomineeRelation />} />,
        },
        {
          path: "masters/salutation",
          element: <App Component={<Salutation />} />,
        },
        {
          path: "masters/companyhassalutation",
          element: <App Component={<CompanyHasSalutation />} />,
        },
        {
          path: "masters/companyhasnomineerelation",
          element: <App Component={<CompanyHasNomineeRelation />} />,
        },
        {
          path: "affiliations/brands",
          element: <App Component={<Brands />} />,
        },
        {
          path: "affiliations/consolidator/commission",
          element: <App Component={<ConsolidatorCertificateWithLocalizationProvider />} />,
        },
        {
          path: "affiliations/models",
          element: <App Component={<Models />} />,
        },
        {
          path: "affiliations/variants",
          element: <App Component={<Variants />} />,
        },
        {
          path: "affiliations/fuels",
          element: <App Component={<Fuels />} />,
        },
        {
          path: "affiliations/transmissions",
          element: <App Component={<Transmissions />} />,
        },
        {
          path: "affiliations/companies",
          element: <App Component={<Companies />} />,
        },
        {
          path: "affiliate/client/companies/add-company",
          element: <App Component={<CompaniesBasicDetails />} />,
        },
        // {
        //   path: "affiliate/client/companies/edit-company",
        //   element: <App Component={<CompaniesEditBasicDetails />} />,
        // },
        {
          path: "affiliate/client/companies/edit-company/:company_id",
          element: <App Component={<CompaniesEditBasicDetails />} />,
        },
        {
          path: "affiliate/client/companies/configuration",
          element: <App Component={<ClientConfiguration />} />,
        },
        {
          path: "affiliate/client/companies/configuration/:company_id",
          element: <App Component={<ClientConfiguration />} />,
        },
        {
          path: "affiliate/client/companies/assigned-products/:company_id",
          element: <App Component={<AssignedProductsToClient />} />,
        },
        // {
        //   path: "affiliations/dealerships",
        //   element: <App Component={<Dealerships />} />,
        // },
        {
          path: "affiliations/partnership",
          element: <App Component={<TravelPartnership />} />,
        },
        {
          path: "affiliations/features",
          element: <App Component={<FeatureManagement />} />,
        },
        {
          path: "affiliations/role-reassignment",
          element: <App Component={<RoleReassignment />} />,
        },
        {
          path: "affiliations/partnership-by-consolidator",
          element: <App Component={<TravelPartnershipByConsolidator  />} />,
        },
        {
          path: "affiliations/consolidator",
          element: <App Component={<Consolidator />} />,
        },
        {
          path: "affiliations/consolidator/credit-note",
          element: <App Component={<CreditNoteCertificateWithLocalizationProvider /> } />
        },
        {
          path: "affiliations/dealerCodeMapping",
          element: <App Component={<DealerCodeMapping />} />,
        },
        {
          path: "affiliate/client/dealerships/assigned-dealerships/:company_id",
          element: <App Component={<AssignedDealershipsToClient />} />,
        },
        {
          path: "navision/admin_wallet",
          element: <App Component={<AdminWallet />} />,
        },
        {
          path: "navision/admin_wallet_closure",
          element: <App Component={<AdminWalletReport />} />,
        },
        {
          path: "navision/wallet_refund",
          element: <App Component={<WalletRefund />} />,
        },
        {
          path: "navision/wallet_map",
          element: <App Component={<WalletMap />} />,
        },
        {
          path: "users/users",
          element: <App Component={<Users dataType={1} />} />,
        },
        {
          path: "pages/page-coming-soon",
          element: <App Component={<PageComingSoon />} />,
        },
        {
          path: "roles",
          element: <App Component={<Roles />} />,
        },
        {
          path: "permissions",
          element: <App Component={<Permissions />} />,
        },
        {
          path: "role/permissions",
          element: <App Component={<RolePermissions />} />,
        },
        {
          path: "user/roles",
          element: <App Component={<UserRoles />} />,
        },
        {
          path: "commissions/static",
          element: <App Component={<StaticCommission />} />,
        },
        {
          path: "commissions/incentivized",
          element: <App Component={<IncentivizedCommission />} />,
        },
        { path: "commissions/status/status", element: <App Component={<Status />} /> },
        { path: "reports/sales", element: <App Component={<SalesReport />} /> },
        { path: "reports/policy", element: <App Component={<PolicyReport />} /> },
        { path: "reports/bp_gst_verification", element: <App Component={<BpGstVerificationReport />} /> },
        { path: "reports/mis", element: <App Component={<MISReport />} /> },
        { path: "reports/mis/role", element: <App Component={<MISReportByRole />} /> },
        { path: "reports/mis/tc_reports", element: <App Component={<TCReport />} /> },

        { path: "reports/dealermis", element: <App Component={<DealerMISReport />} /> },
        { path: "reports/rsa-sales", element: <App Component={<RsaSalesReport />} /> },
        { path: "reports/target-allotment", element: <App Component={<TargetAllotment />} /> },
        { path: "reports/target-vs-achievement", element: <App Component={<TargetVsAchievement />} /> },
        { path: "targetAllotment/TargetAlloment", element: <App Component={<TargetAlloment />} /> },
        { path: "reports/dealer_kyc_reports", element: <App Component={<DealerKYC />} /> },
        { path: "reports/document_reports", element: <App Component={<DocumentReport />} /> },
        { path : "reports/finance-report", element: <App Component={<FinanceReport />} /> },
        { path : "reports/mis-beta-report", element: <App Component={<MisBetaReport />} /> },
        { path: "reports/finance-invoice-report", element: <App Component={<FinanceInvoiceReport />} /> },
        { path: "reports/finance-tc-data", element: <App Component={<FinanceTcData />} /> },
        { path: "reports/plan-report", element: <App Component={<PlanWiseReport />} /> },
        {path: "reports/aggregator-report", element: <App Component={<AggregatorFinanceReport />} /> },
        { path: "reports/reconcile-report", element: <App Component={<ReconcileReport />} /> },
        { path: "reports/payment-transactions", element: <App Component={<PaymentTransactions />} /> },

        {
          path: "reports/admin/wallet",
          element: <App Component={<AdminWalletHistory />} />,
        },
        {
          path: "reports/admin/ea_wallet",
          element: <App Component={<EAWalletHistory />} />,
        },
        {
          path: "reports/user/wallet",
          element: <App Component={<UserWalletPartnershipReport />} />,
        },
        {
          path: "/reports/user/partership-wallet",
          element: <App Component={<UserWalletPartnershipReport />} />,
        },
        {
          path: "reports/wallet-refund-list",
          element: <App Component={<WalletRefundList />} />,
        },

        {
          path: "logs/server/access",
          element: <App Component={<AccessLogs />} />,
        },
        {
          path: "logs/policy",
          element: <App Component={<PolicyElastic />} />,
        },  
        {
          path: "sales/policy",
          element: <App Component={<PolicyElastic />} />,
        },
        {
          path: "logs/server/error",
          element: <App Component={<ErrorLogs />} />,
        },
        {
          path: "logs/server/cron",
          element: <App Component={<CronLogs />} />,
        },
        { path: "logs/api", element: <App Component={<APILogs />} /> },
        {
          path: "logs/activity",
          element: <App Component={<ActivityLogs />} />,
        },
        {
          path: "affiliations/dsp",
          element: <App Component={<DSP />} />,
        },
        {
          path: "account/profile/edit",
          element: <App Component={<MyAccount />} />,
        },
        {
          path: "account/password/edit",
          element: <App Component={<ChangePassword />} />,
        },
        {
          path: "sales/products/assign",
          element: <App Component={<ProductsAssign />} />,
        },
        {
          path: "sales/policies/assign-plan",
          element: <App Component={<AssignPlan />} />,
        },
        {
          path: "sales/policies/view-assigned-plans",
          element: <App Component={<ViewAssignedPlans />} />,
        },
        {
          path: "sales/policies/partnership-assigned-plans",
          element: <App Component={<PartnershipAssignedPlans />} />,
        },
        // {
        //   path: "sales/policies/create/:sales_category_id",
        //   // element: <App Component={<PolicyCreate />} />, // one page policy punch 
        //   element: <App Component={<PolicyCreateWithStepper />} />, // stepper policy punch
        // },
        // {
        //   path: "sales/one-page-policies/create/:sales_category_id",
        //   element: <App Component={<PolicyCreate />} />, // one page policy punch 
        // },
        // {
        //   path: "sales/policies/create/:sales_category_id",
        //   element: <App Component={<PolicyCreateWithStepper />} />, // stepper policy punch
        // },
        {
          path: "sales/policies/create/:sales_category_id",
          element: <App Component={<SalesPolicyCreateWithStepper />} />, // stepper sales policy punch travel strategy
        },
        {
          path: "sales/policies/create-new/:sales_category_id",
          element: <App Component={<SalesPolicyCreateNewWithStepper />} />, // stepper sales policy punch travel strategy
        },
        {
          path: "sales/policies/bulk",
          element: <App Component={<BulkPolicyUpload />} />,
        },
        {
          path: "reports/edit-target-allotment",
          element: <App Component={<EditTargetAllotment />} />,
        },
        {
          path: "affiliations/companies/users",
          // element: <App Component={<CompanyUsers />} />,
          element: <App Component={<Users dataType={2} />} />,

        },
        {
          // path: "partnership/users",
          path: "affiliations/partnership/users",
          // element: <App Component={<DealershipUsers />} />,
          element: <App Component={<Users dataType={3} />} />,

        },
        {
          // path: "partnership/users",
          path: "affiliations/conslidator/users",
          // element: <App Component={<DealershipUsers />} />,
          element: <App Component={<Users />} />,

        },
        {
          path: "affiliations/dealerships/bulkupload",
          element: <App Component={<BulkUploadDealership />} />,
        },
        {
          path: "documents/helpdesk",
          element: <App Component={<Helpdesk />} />,
        },
        { path: "documents/kyc", element: <App Component={<KYC />} /> },
        { path: "documents/kycBackup", element: <App Component={<KYCBackup />} /> },
         { path: "documents/bulk", element: <App Component={<BulkDocument />} /> },
         { path: "documents/bulk/success", element: <App Component={<BulkDocumentSuccessPage />} /> },
         { path: "documents/bulk/proposer-details", element: <App Component={<BulkProposerDetaillsPage />} /> },
         { path: "documents/bulk/payment", element: <App Component={<BulkPaymentDetailsPage />} /> },
         {path: "documents/bulk/invoices", element: <App Component={<BulkInvoiceWalletWithLocalizationProvider />} /> },
         {path: "documents/bulk/cutnpay", element: <App Component={<BulkInvoiceCutnpayWithLocalizationProvider />} /> },
         {path: "documents/bulk/msc-bulk-claim", element: <App Component={<MscBulkClaimCpgPage />} /> },
         {path: "documents/membership-calculator", element: <App Component={<PremiumCalculator />} /> },
        {
          path: "documents/viewhelpdesk",
          element: <App Component={<Viewhelpdesk />} />,
        },
        {
          path: "e-learning/courses",
          element: <App Component={<ELearningCourses />} />,
        },
        {
          path: "e-learning/sections",
          element: <App Component={<ELearningCourseSections />} />,
        },
        {
          path: "e-learning/courses_module",
          element: <App Component={<ECourseModule />} />,
        },
        {
          path: "e-learning/courses_topic",
          element: <App Component={<ECourseModuleTopic />} />,
        },
        {
          path: "e-learning/courses_quiz",
          element: <App Component={<ECourseModuleQuiz />} />,
        },
        {
          path: "e-learning/play",
          element: <App Component={<ELearningPlay />} />,
        },
        {
          path: "e-learning/quiz",
          element: <App Component={<ELearningQuiz />} />,
        },
        {
          path: "manage/e-learning/course",
          element: <App Component={<ManageCourse />} />,
        },
        {
          path: "manage/e-learning/course/sections",
          element: <App Component={<ManageCourseSections />} />,
        },
        {
          path: "requests/my-requests",
          element: <App Component={<MyRequests  />} />,
        },
        {
          path: "requests/cashify-my-requests",
          element: <App Component={<CashifyMyRequests  />} />,
        },        
        {
          path: "requests/admin-requests",
          element: <App Component={<AdminRequests  />} />,
        },        
        {
          path: "requests/requests-for-me",
          element: <App Component={<RequestsForMe type='my-requests' />} />,
        },
        {
          path: "requests/cashify-requests-for-me",
          element: <App Component={<CashifyRequestsForMe type='my-requests' />} />,
        },
        {
          path: "requests/cashify-my-actions",
          element: <App Component={<CashifyRequestsForMe  type='my-actions' />} />,
        },
        //mis report
        { path: "reports/cashify-mis",
          element: <App Component={<CashifyMISReport />} />
        },
        { path: "reports/sales-report-cashify",
          element: <App Component={<CashifySalesReport />} />
        },
        {
          path: "requests/my-actions",
          element: <App Component={<RequestsForMe type='my-actions'  />} />,
        },
        {
          path: "requests/cashify-all-request",
          element: <App Component={<CashifyAllRequest />} />,
        },
        {
          path: "requests/upload-image-to-s3",
          element: <App Component={<UploadImageToS3 />} />,
        },
        {
          path: "wallet/credits",
          element: checkRoleAccess(['DEALERSHIP_MANAGER'], <App Component={<WalletCredits />} />),
        },
        {
          path: "pages/auth/loginWithBgImg1",
          element: <App Component={<LoginWithBgImage />} />,
        },
        {
          path: "affiliations/dms",
          element: <App Component={<DMSData />} />,
        },
        {
          path: "affiliations/dmsList",
          element: <App Component={<DMSList />} />,
        },
        // {
        //   path: "wallet/statement",
        //   element: <App Component={<UserWalletStatement />} />,
        // },
        {
          path: "sales/taxes/countries",
          element: <App Component={<Countries />} />,
        },
        { path: "sales/taxes/states", element: <App Component={<States />} /> },
        {
          path: "sales/taxes/parent-tax",
          element: <App Component={<ParentTaxes />} />,
        },
        {
          path: "sales/taxes/sub-taxes",
          element: <App Component={<SubTaxes />} />,
        },
        {
          path: "reports/bdm-sales",
          element: <App Component={<BdmSalesReport />} />,
        },
        {
          path: "reports/BDM-Data",
          element: <App Component={<BdmTable />} />,
        },
        {
          path: "sales/bdm-policies",
          element: <App Component={<BdmPolicies />} />,
        },
        {
          path: "sales/products/productList",
          element: <App Component={<ProductLists />} />,
        },
        {
          path: "users/add",
          element: <App Component={<AddUser />} />,
        },
        {
          path: "access-permission",
          element: <App Component={<Permission />} />,
        },
        {
          path: "online-policy-punch-success",
          element: <App Component={<PolicySuccess />} />,
        },
        {
          path: "online-policy-punch-failure",
          element: <App Component={<PolicyFailure />} />,
        },
        {
          path: "payment-success",
          element: <App Component={<PaymentSuccess />} />,
        },
        {
          path: "payment-failure",
          element: <App Component={<PaymentFailure />} />,
        },
        {
          path: "payment/payment-success",
          element: <PayuSuccess />,
        },
        {
          path: "payment/payment-failure",
          element: <PayuFailure /> ,
        },
        {
          path: "session",
          element: <App Component={<Session />} />,
        },
        {
          path: "getOtp",
          element: <App Component={<GetOtp />} />,
        },
        {
          path: "automated_email",
          element: <App Component={<AutomatedEmail />} />,
        },
        {
          path: "reports/visiting_reports",
          element: <App Component={<VisitingReport />} />,
        },
        {
          path: "reports/IndiaMap",
          element: <App Component={<IndiaMap />} />
        },
      ],
    },
    { path: appRoutes.NOT_FOUND, element: <Error400 /> },
  ]);
}

const App = Loadable(lazy(() => import("../components/app")));
const Permission = Loadable(lazy(() => import("../components/permission_management/Permissions")));
const PolicySuccess = Loadable(lazy(() => import("../components/sales/policies/PolicySuccess")));
const PolicyFailure = Loadable(lazy(() => import("../components/sales/policies/PolicyFailure")));
const PaymentSuccess = Loadable(lazy(() => import("../components/payment/PaymentSuccess")));
const PaymentFailure = Loadable(lazy(() => import("../components/payment/PaymentFailure")));
const PayuSuccess = Loadable(lazy(() => import("../components/payment/PayuSuccess")));
const PayuFailure = Loadable(lazy(() => import("../components/payment/PayuFailure")));
const Signin = Loadable(lazy(() => import("../auth/signin")));
const RememberMe = Loadable(lazy(() => import("../auth/rememberMe")));
const Login = Loadable(lazy(() => import("../pages/authentication/login")));
const CallBackLogin = Loadable(lazy(() => import("../pages/authentication/CallBackupUrl")));
const LoginWithBgImage = Loadable(
  lazy(() => import("../pages/authentication/loginWithBgImage"))
);
const LoginWithBgVideo = Loadable(
  lazy(() => import("../pages/authentication/loginWithBgVideo"))
);
const LoginWithValidation = Loadable(
  lazy(() => import("../pages/authentication/loginwithValidation"))
);
const Register = Loadable(
  lazy(() => import("../pages/authentication/register"))
);
const RegisterWithBgImage = Loadable(
  lazy(() => import("../pages/authentication/registerWithBgImage"))
);
const RegisterWithBgVideo = Loadable(
  lazy(() => import("../pages/authentication/registerWithBgVideo"))
);
const UnlockUser = Loadable(
  lazy(() => import("../pages/authentication/unlockUser"))
);
const Forgetpwd = Loadable(
  lazy(() => import("../pages/authentication/forgetpwd"))
);
const Resetpwd = Loadable(
  lazy(() => import("../pages/authentication/resetpwd"))
);
const Error400 = Loadable(lazy(() => import("../pages/errors/error400")));
const Error401 = Loadable(lazy(() => import("../pages/errors/error401")));
const Error403 = Loadable(lazy(() => import("../pages/errors/error403")));
const Error404 = Loadable(lazy(() => import("../pages/errors/error404")));
const Error500 = Loadable(lazy(() => import("../pages/errors/error500")));
const Error503 = Loadable(lazy(() => import("../pages/errors/error503")));
const Comingsoon = Loadable(
  lazy(() => import("../pages/comingSoon/comingsoon"))
);
const ComingsoonImg = Loadable(
  lazy(() => import("../pages/comingSoon/comingsoonImg"))
);
const ComingsoonVideo = Loadable(
  lazy(() => import("../pages/comingSoon/comingsoonVideo"))
);
const Maintenance = Loadable(lazy(() => import("../pages/maintenance")));
const Callback = Loadable(lazy(() => import("../auth/callback")));
const ForgotPassword = Loadable(lazy(() => import("../auth/forgotPassword")));
const ValidateOTP = Loadable(lazy(() => import("../auth/validateOTP")));
const MailSent = Loadable(lazy(() => import("../auth/mail-sent")));
const ResetPassword = Loadable(lazy(() => import("../auth/resetPassword")));
const SelectUserRole = Loadable(lazy(() => import("../auth/selectUserRole")));
const FirstLoginValidateOTP = Loadable(
  lazy(() => import("../auth/firstLoginValidateOTP"))
);
const Allocation = Loadable(
  lazy(() => import("../components/allocation/Allocation"))
);
const Hierarchy = Loadable(
  lazy(() => import("../components/hierarchy/Hierarchy"))
);
const TargetAlloment = Loadable(
  lazy(() => import("../components/targetAllotment/TargetAlloment"))
);
const TargetPage = Loadable(
  lazy(() => import("../components/targetAllotment/TargetPage"))
);
const TeamMemberDashboard = Loadable(
  lazy(() => import("../components/dashboard/TeamMemberDashboard"))
);
const GstVerificationDashboard = Loadable(
  lazy(() => import("../components/bpGstVerification/bpGstVerification.jsx"))
);
const DealerDashboard = Loadable(
  lazy(() => import("../components/dashboard/DealerDashboard"))
);
const CcmDashboard = Loadable(
  lazy(() => import("../components/dashboard/CcmDashboard"))
);
const DspDashboard = Loadable(
  lazy(() => import("../components/dashboard/DspDashboard"))
);
const FinanceDasbaord = Loadable(
  lazy(() => import("../components/dashboard/FinanceDasbaord"))
);
const Home = Loadable(lazy(() => import("../components/dashboard/Home")));
const vehicleDetails = Loadable(
  lazy(() => import("../components/dashboard/vehicleDetais"))
);
const vehicleDetailsInvoice = Loadable(
  lazy(() => import("../components/dashboard/vehicleDetailsInovie"))
);

//Protected Dashboard routes
// const SaleCategory = Loadable(lazy(() => import('../components/sales/categories/categories')))
// Dashboard
const Default = Loadable(lazy(() => import("../components/dashboard/default")));
const RolesSelection = Loadable(lazy(() => import("../auth/RolesSelection")));
const Ecommerce = Loadable(
  lazy(() => import("../components/dashboard/ecommerce"))
);

// Widgets
const GeneralWidget = Loadable(
  lazy(() => import("../components/widgets/general"))
);
const ChartsWidget = Loadable(
  lazy(() => import("../components/widgets/charts"))
);

const ConsolidatorCertificateWithLocalizationProvider = Loadable(
  lazy(() => import("../components/affiliations/clients/consolidator/ConsolidatorCommissionEdited.jsx"))
);
// UI KitsC:\Users\sshete.extern\Documents\TravellingProject\Travel-Strategy-App\src\.jsx
const StateColor = Loadable(
  lazy(() => import("../components/ui-kits/statecolor"))
);
const Typography = Loadable(
  lazy(() => import("../components/ui-kits/typography"))
);
const Avatars = Loadable(lazy(() => import("../components/ui-kits/avatars")));
const HelperClasses = Loadable(
  lazy(() => import("../components/ui-kits/helperClasses"))
);
const Grid = Loadable(lazy(() => import("../components/ui-kits/grid")));
const TagAndPills = Loadable(
  lazy(() => import("../components/ui-kits/tagAndPills"))
);
const Progress = Loadable(lazy(() => import("../components/ui-kits/progress")));
const Modal = Loadable(lazy(() => import("../components/ui-kits/modal")));
const Alert = Loadable(lazy(() => import("../components/ui-kits/alert")));
const Popover = Loadable(lazy(() => import("../components/ui-kits/popover")));
const Tooltip = Loadable(lazy(() => import("../components/ui-kits/tooltip")));
const Spinner = Loadable(lazy(() => import("../components/ui-kits/spinner")));
const Dropdown = Loadable(lazy(() => import("../components/ui-kits/dropDown")));
const TabBootstrap = Loadable(
  lazy(() => import("../components/ui-kits/tabs/tabBootstrap"))
);
const TabLine = Loadable(
  lazy(() => import("../components/ui-kits/tabs/tabLine"))
);
const Accordian = Loadable(
  lazy(() => import("../components/ui-kits/accordian"))
);
const Shadow = Loadable(lazy(() => import("../components/ui-kits/shadow")));
const List = Loadable(lazy(() => import("../components/ui-kits/list")));

// Bonus UI
const Scrolling = Loadable(
  lazy(() => import("../components/bonus_ui/scrolling"))
);
const BootstrapNotify = Loadable(
  lazy(() => import("../components/bonus_ui/bootstrapNotify"))
);
const Rating = Loadable(lazy(() => import("../components/bonus_ui/rating")));
const Dropzone = Loadable(
  lazy(() => import("../components/bonus_ui/dropzone"))
);
const SweetAlert = Loadable(
  lazy(() => import("../components/bonus_ui/sweetAlert"))
);
const Tour = Loadable(lazy(() => import("../components/bonus_ui/tour")));
const Sticky = Loadable(lazy(() => import("../components/bonus_ui/sticky")));
const Breadcrumb = Loadable(
  lazy(() => import("../components/bonus_ui/breadcrumb"))
);
const Imagecrop = Loadable(
  lazy(() => import("../components/bonus_ui/imagecrop"))
);
const RangeSlider = Loadable(
  lazy(() => import("../components/bonus_ui/rangeSlider"))
);
const Carousel = Loadable(
  lazy(() => import("../components/bonus_ui/carousel"))
);
const Ribbons = Loadable(lazy(() => import("../components/bonus_ui/ribbons")));
const Pagination = Loadable(
  lazy(() => import("../components/bonus_ui/pagination"))
);
const DragAndDrop = Loadable(
  lazy(() => import("../components/bonus_ui/dragAndDrop"))
);
const UploadImage = Loadable(
  lazy(() => import("../components/bonus_ui/uploadImage"))
);

// Cards
const BasicCards = Loadable(
  lazy(() => import("../components/bonus_ui/cards/basicCards"))
);
const ThemeCards = Loadable(
  lazy(() => import("../components/bonus_ui/cards/themeCards"))
);
const TabCard = Loadable(
  lazy(() => import("../components/bonus_ui/cards/tabCard"))
);
const DraggingCards = Loadable(
  lazy(() => import("../components/bonus_ui/cards/draggingCards"))
);

// Timeline
const Timeline1 = Loadable(
  lazy(() => import("../components/bonus_ui/timelines/timeline"))
);

// Icons
const FlagIcons = Loadable(lazy(() => import("../components/icons/flagIcons")));
const FontAwsomeIcon = Loadable(
  lazy(() => import("../components/icons/fontAwsomeIcon"))
);
const IcoIcons = Loadable(lazy(() => import("../components/icons/icoIcons")));
const ThemifyIcons = Loadable(
  lazy(() => import("../components/icons/themifyIcons"))
);
const FeatherIcons = Loadable(
  lazy(() => import("../components/icons/featherIcons"))
);
const WeatherIcons = Loadable(
  lazy(() => import("../components/icons/weatherIcons"))
);

// Buttons
const DefaultButton = Loadable(
  lazy(() => import("../components/buttons/default-Button"))
);
const EdgeButton = Loadable(
  lazy(() => import("../components/buttons/edgeButton"))
);
const FlatButton = Loadable(
  lazy(() => import("../components/buttons/flatButton"))
);
const GroupButton = Loadable(
  lazy(() => import("../components/buttons/groupButton"))
);
const RaisedButton = Loadable(
  lazy(() => import("../components/buttons/raisedButton"))
);

// Forms
const FormValidation = Loadable(
  lazy(() => import("../components/forms/form-control/form-validation"))
);
const AffiliationCompaniesTest = Loadable(
  lazy(() => import("../components/forms/form-control/AffiliationsCompaniesTest"))
);
const BaseInput = Loadable(
  lazy(() => import("../components/forms/form-control/baseInput"))
);
const InputGroup = Loadable(
  lazy(() => import("../components/forms/form-control/inputGroup"))
);
const MegaOption = Loadable(
  lazy(() => import("../components/forms/form-control/megaOption"))
);
const CheckboxandRadio = Loadable(
  lazy(() => import("../components/forms/form-control/checkboxandRadio"))
);

// Form Layout
const FormDefault = Loadable(
  lazy(() => import("../components/forms/form-layout/formDefault"))
);
const FormWizard1 = Loadable(
  lazy(() =>
    import("../components/forms/form-layout/form-wizard-1/formwizard1")
  )
);

// Form Widgets
const Datepicker = Loadable(
  lazy(() => import("../components/forms/form-widget/datepicker"))
);
const Timepicker = Loadable(
  lazy(() =>
    import("../components/forms/form-widget/timepickerComponent/timepicker")
  )
);
const Typeahead = Loadable(
  lazy(() =>
    import("../components/forms/form-widget/typeaheadComponent/typeahead")
  )
);

// Tables
const BasicTabels = Loadable(
  lazy(() => import("../components/tables/basicTable"))
);
const BorderTable = Loadable(
  lazy(() => import("../components/tables/borderTable"))
);
const SizingTable = Loadable(
  lazy(() => import("../components/tables/sizingTable"))
);
const StylingTable = Loadable(
  lazy(() => import("../components/tables/stylingTable"))
);
const DataTable = Loadable(
  lazy(() => import("../components/tables/dataTable"))
);

// Charts
const Apexcharts = Loadable(
  lazy(() => import("../components/charts/apexCharts"))
);
const GoogleCharts = Loadable(
  lazy(() => import("../components/charts/googleCharts"))
);
const KnobChart = Loadable(
  lazy(() => import("../components/charts/knobChart"))
);
const Chartist = Loadable(
  lazy(() => import("../components/charts/chartistCharts"))
);

// Gallery
const ImageGallery = Loadable(
  lazy(() => import("../components/gallery/imageGallery"))
);
const ImageWithDesc = Loadable(
  lazy(() => import("../components/gallery/imageWithDesc"))
);
const MesonryGallery = Loadable(
  lazy(() => import("../components/gallery/mesonryGallery"))
);
const MesonryDesc = Loadable(
  lazy(() => import("../components/gallery/mesonryDesc"))
);
const ImageHover = Loadable(
  lazy(() => import("../components/gallery/imageHover"))
);

// Blog
const BlogDetail = Loadable(
  lazy(() => import("../components/blog/blogDetail"))
);
const BlogSingle = Loadable(
  lazy(() => import("../components/blog/blogSingle"))
);
const BlogPost = Loadable(lazy(() => import("../components/blog/blogPost")));

// Job Search
const CardView = Loadable(
  lazy(() => import("../components/jobSearch/cardView"))
);
const JobList = Loadable(
  lazy(() => import("../components/jobSearch/job-list"))
);
const JobDetail = Loadable(
  lazy(() => import("../components/jobSearch/job-detail"))
);
const JobApply = Loadable(
  lazy(() => import("../components/jobSearch/job-apply"))
);

// Learning
const Learninglist = Loadable(
  lazy(() => import("../components/learning/learning-list"))
);
const LearningDeatil = Loadable(
  lazy(() => import("../components/learning/learning-deatil"))
);

// Calendar
const BasicCalender = Loadable(
  lazy(() => import("../components/calendar/basicCalendar"))
);
const DraggableCalendar = Loadable(
  lazy(() => import("../components/calendar/draggableCalendar"))
);

// Users
const UserProfile = Loadable(
  lazy(() => import("../components/users/userProfile"))
);
const UserEdit = Loadable(lazy(() => import("../components/users/userEdit")));
const UserCards = Loadable(lazy(() => import("../components/users/userCards")));

// Maps
const GoogleMap = Loadable(lazy(() => import("../components/map/googleMap")));

// Editor
const CkEditor = Loadable(lazy(() => import("../components/editor/ckEditor")));
const MdeEditor = Loadable(
  lazy(() => import("../components/editor/mdeEditor"))
);

// Social App
const SocialApp = Loadable(lazy(() => import("../components/social-app")));

// FAQ page
const FaqComponent = Loadable(lazy(() => import("../components/faq")));

// Knowledgebase page
const KnowledgebaseComponent = Loadable(
  lazy(() => import("../components/knowledgebase"))
);

// Support Ticket
const SupportTicket = Loadable(
  lazy(() => import("../components/support-ticket"))
);

// Sample page
const Sample = Loadable(lazy(() => import("../components/sample")));
const Playground = Loadable(lazy(() => import("../components/sample/playground")));
const MisReports = Loadable(lazy(() => import("../components/reports/mis-cron")));

// Search page
const Search = Loadable(lazy(() => import("../components/search")));

// E-commerce app
const Product = Loadable(
  lazy(() => import("../components/application/ecommerce-app/product"))
);
const ProductDetail = Loadable(
  lazy(() => import("../components/application/ecommerce-app/productpage"))
);
const Cart = Loadable(
  lazy(() => import("../components/application/ecommerce-app/cart"))
);
const Wishlist = Loadable(
  lazy(() => import("../components/application/ecommerce-app/wishlist"))
);
const Productlist = Loadable(
  lazy(() => import("../components/application/ecommerce-app/productlist"))
);
const Paymentdetails = Loadable(
  lazy(() => import("../components/application/ecommerce-app/paymentdetails"))
);
const OrderHistory = Loadable(
  lazy(() => import("../components/application/ecommerce-app/orderHistory"))
);
const Checkout = Loadable(
  lazy(() => import("../components/application/ecommerce-app/checkout"))
);
// const Invoice = Loadable(
//   lazy(() => import("../components/application/ecommerce-app/invoice"))
// );
const Pricing = Loadable(
  lazy(() => import("../components/application/ecommerce-app/pricing"))
);

// EPortal2.0 Routes
const SaleCategory = Loadable(
  lazy(() => import("../components/sales/categories/categories"))
);
const Products = Loadable(
  lazy(() => import("../components/sales/products/products"))
);
const Cashifyproducts = Loadable(
  lazy(() => import("../components/sales/products/cashifyProducts"))
);
const Services = Loadable(
  lazy(() => import("../components/sales/services/services"))
);
const Coupons = Loadable(
  lazy(() => import("../components/sales/coupons/coupons"))
);
const Policies = Loadable(
  lazy(() => import("../components/sales/policies/listing")) // policy generic listing
);
const Certificate = Loadable(
  lazy(() => import("../components/sales/policies/certificate"))
);
const AddDocument = Loadable(
  lazy(() => import("../components/sales/policies/AddDocument"))
);
const NyomPolicies = Loadable(
  lazy(() => import("../components/sales/policies/nyom/nyom-policies"))
);
const Quotation = Loadable(
  lazy(() => import("../components/sales/policies/quotations/quotation"))
);
const SyncDashboard = Loadable(
  lazy(() => import("../components/syncDashboard/syncDashboard"))
);
const Invoice = Loadable(
  lazy(() => import("../components/sales/policies/invoice"))
);
const InvoiceNormalWallet = Loadable(
  lazy(() => import("../components/sales/policies/invoice-normal-wallet"))
);
const CsutomerPaymentInvoice = Loadable(
  lazy(() => import("../components/sales/policies/customer-invoice-payment"))
);
const Commission = Loadable(
  lazy(() => import("../components/sales/commission/commission.jsx"))
);
const Certificate2 = Loadable(
  lazy(() => import("../components/sales/policies/certificate2"))
);
const SearchCertificates = Loadable(
  lazy(() => import("../components/sales/certificates/search-certificates"))
);
const Customers = Loadable(
  lazy(() => import("../components/sales/policies/customers"))
);
const Types = Loadable(
  lazy(() => import("../components/masters/types/types"))
);
const City = Loadable(
  lazy(() => import("../components/masters/city_master/city"))
);
const Assistance = Loadable(
  lazy(() => import("../components/masters/assistance-master"))
);

const Zone = Loadable(
  lazy(() => import("../components/masters/zone/zone"))
);
const Pincode = Loadable(
  lazy(() => import("../components/masters/pincode/pincode"))
);
const InsPincode = Loadable(
  lazy(() => import("../components/masters/insurance_pincode/ins_pincode"))
);
const CancellationReasons = Loadable(
  lazy(() => import("../components/masters/cancellation_reason/cancellation_reason"))
);
const CompanyTypes = Loadable(
  lazy(() => import("../components/masters/company_types/CompanyTypes"))
);

const Gender = Loadable(
  lazy(() => import("../components/masters/gender/Gender.jsx"))
);

const Salitutaion = Loadable(
  lazy(() => import("../components/masters/salutation/Salutation.jsx"))
);

const NomineeRelation = Loadable(
  lazy(() => import("../components/masters/nominee_relation/NomineeRelation.jsx"))
);

const CompanyHasSalutation = Loadable(
  lazy(() => import("../components/masters/company_has_salutation/CompanyHasSalutation.jsx"))
);

const CompanyHasNomineeRelation = Loadable(
  lazy(() => import("../components/masters/company_has_nominee_relation/CompanyHasNomineeRelation.jsx"))
);

const CompanyTypesGeo = Loadable(
  lazy(() => import("../components/masters/company_types_geo/CompanyTypesGeo"))
);

const Category = Loadable(
  lazy(() => import("../components/masters/category/categories"))
);
const ServiceType = Loadable(
  lazy(() => import("../components/masters/service_type/service-type"))
); 
const Country = Loadable(
  lazy(() => import("../components/masters/country/country"))
);
const Geographical_Cover = Loadable(
  lazy(() => import("../components/masters/geographical_cover/geographical_cover"))
);
const Service = Loadable(
  lazy(() => import("../components/masters/service/service"))
);
const MainService = Loadable(
  lazy(() => import("../components/masters/main-service/main-service"))
);
const Brands = Loadable(
  lazy(() => import("../components/affiliations/manufacturers/brands/brands"))
);
const Models = Loadable(
  lazy(() => import("../components/affiliations/manufacturers/models/models"))
);
const Variants = Loadable(
  lazy(() =>
    import("../components/affiliations/manufacturers/variants/variants")
  )
);
const Fuels = Loadable(
  lazy(() => import("../components/affiliations/manufacturers/fuels/fuels"))
);
const Transmissions = Loadable(
  lazy(() =>
    import(
      "../components/affiliations/manufacturers/transmissions/transmissions"
    )
  )
);
const Companies = Loadable(
  lazy(() => import("../components/affiliations/clients/companies/companies"))
);
const CompaniesBasicDetails = Loadable(
  lazy(() => import("../components/affiliations/clients/companies/modals/add-company/basic-details"))
);
const CompaniesEditBasicDetails = Loadable(
  lazy(() => import("../components/affiliations/clients/companies/modals/edit-company/basic-details"))
);
const ClientConfiguration = Loadable(
  lazy(() => import("../components/affiliations/clients/companies/modals/add-company/ClientConfiguration"))
);
// const Dealerships = Loadable(
//   lazy(() =>
//     import("../components/affiliations/clients/dealerships/dealerships")
//   )
// );
const TravelPartnership = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/partnerships/partnership")
  )
);
// const TravelPartnershipByConsolidator = Loadable(
//   lazy(() =>
//     import("../components/user_management/users/users")
//   )
// );
const Consolidator = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/consolidator/consolidator")
  )
);
const TravelPartnershipByConsolidator = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/partnerships/partnership-by-consolidator")
  )
);
const DealerCodeMapping = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/dealerCodeMapping/dealer-code-mapping")
  )
);
const AdminWallet = Loadable(
  lazy(() => import("../components/navision/admin_wallet"))
);
// import WalletRefundList from "../components/wallet/wallet-refund";
const WalletRefundList = Loadable(
  lazy(() => import("../components/wallet/WalletRefundList"))
);
const WalletRefund = Loadable(
  lazy(() => import("../components/navision/wallet_refund"))
);
const WalletMap = Loadable(
  lazy(() => import("../components/navision/WalletMap"))
);
const Users = Loadable(
  lazy(() => import("../components/user_management/users/users"))
);
const PageComingSoon = Loadable(
  lazy(() => import("../pages/page-coming-soon"))
);
const Roles = Loadable(
  lazy(() => import("../components/user_management/acl/roles/roles"))
);
const Permissions = Loadable(
  lazy(() =>
    import("../components/user_management/acl/permissions/permissions")
  )
);
const RolePermissions = Loadable(
  lazy(() =>
    import(
      "../components/user_management/acl/role_permissions/role_permissions"
    )
  )
);
const UserRoles = Loadable(
  lazy(() => import("../components/user_management/acl/user_roles/user_roles"))
);
const StaticCommission = Loadable(
  lazy(() => import("../components/commissions/static/static"))
);
const IncentivizedCommission = Loadable(
  lazy(() => import("../components/commissions/incentivized/incentivized"))
);
const Status = Loadable(
  lazy(() => import("../components/commissions/status/status"))
);
const SalesReport = Loadable(
  lazy(() => import("../components/reports/sales/sales-report"))
);
const PolicyReport = Loadable(
  lazy(() => import("../components/reports/sales/PolicyReport.jsx"))
);
const MISReport = Loadable(
  lazy(() => import("../components/reports/sales/MISReport.jsx"))
);
const MISReportByRole = Loadable(
  lazy(() => import("../components/reports/sales/MISReportByRole.jsx"))
);
const TCReport = Loadable(
  lazy(() => import("../components/reports/sales/TCReport.jsx"))
);
const CashifyMISReport = Loadable(
  lazy(() => import("../components/reports/sales/CashifyMISReport.jsx"))
);
const CashifySalesReport = Loadable(
  lazy(() => import("../components/reports/sales/CashifySalesreport.jsx"))
);
const DealerKYC = Loadable(
  lazy(() => import("../components/reports/sales/Dealer-KYC-Reports"))
);
const DocumentReport = Loadable(
  lazy(() => import("../components/reports/sales/Document-Reports.jsx"))
);
const FinanceReport = Loadable(
  lazy(() => import("../components/reports/sales/finance-report.jsx"))
);
const MisBetaReport = Loadable(
  lazy(() => import("../components/reports/sales/MisBetaReport.jsx"))
);
const FinanceInvoiceReport = Loadable(
  lazy(() => import("../components/reports/sales/finance-invoice-report.jsx"))
);
const FinanceTcData = Loadable(
  lazy(() => import("../components/reports/sales/finance-tc-data.jsx"))
);
const PlanWiseReport = Loadable(
  lazy(() => import("../components/reports/sales/plan-report.jsx"))
);
const AggregatorFinanceReport = Loadable(
  lazy(() => import("../components/reports/aggregator/AggregatorFinanceReport.jsx"))
);
const DealerMISReport = Loadable(
  lazy(() => import("../components/reports/sales/dealer-mis-report"))
);
const RsaSalesReport = Loadable(
  lazy(() => import("../components/reports/sales/rsa-sales-report"))
);
const TargetAllotment = Loadable(
  lazy(() => import("../components/reports/sales/target-allotment"))
);
const TargetVsAchievement = Loadable(
  lazy(() => import("../components/reports/sales/target-vs-achievement"))
);
const AdminWalletReport = Loadable(
  lazy(() => import("../components/reports/wallet/admin-wallet-report"))
);
const UserWalletReport = Loadable(
  lazy(() => import("../components/reports/wallet/user-wallet-report"))
);
const UserWalletPartnershipReport = Loadable(
  lazy(() => import("../components/reports/wallet/user-wallet-partnership-report"))
);
const PaymentTransactions = Loadable(
  lazy(() => import("../components/sales/reports/PaymentTransactions.jsx"))
);
const AccessLogs = Loadable(  
  lazy(() => import("../components/logs/server/access-log/access-log"))
);
const PolicyElastic = Loadable(
  lazy(() => import("../components/logs/server/policy"))

);
const ErrorLogs = Loadable(
  lazy(() => import("../components/logs/server/error-log/error-log"))
);
const CronLogs = Loadable(
  lazy(() => import("../components/logs/server/cron-log/cron-log"))
);
const APILogs = Loadable(
  lazy(() => import("../components/logs/api/api-log/api-log"))
);
const ActivityLogs = Loadable(
  lazy(() => import("../components/logs/api/activity-log/activity-log"))
);
const DSP = Loadable(
  lazy(() => import("../components/affiliations/clients/dsp/dsp"))
);
const MyAccount = Loadable(
  lazy(() => import("../components/account/my-account"))
);
const ChangePassword = Loadable(
  lazy(() => import("../components/account/change-password"))
);
const ProductsAssign = Loadable(
  lazy(() => import("../components/sales/products/products-assign"))
);
const AssignPlan = Loadable(
  lazy(() => import("../components/sales/policies/assign-plan/assign-plan.jsx"))
);
const ViewAssignedPlans = Loadable(
  lazy(() => import("../components/sales/policies/assign-plan/view-assigned-plans.jsx"))
);
const PartnershipAssignedPlans = Loadable(
  lazy(() => import("../components/sales/policies/assign-plan/partnership-assigned-plans.jsx"))
);
const PolicyCreate = Loadable(
  lazy(() => import("../components/sales/policies/policy-create/policy-create"))
);
const PolicyCreateWithStepper = Loadable(
  lazy(() => import("../components/sales/policies/policy-create/PolicyCreateWithStepper.jsx"))
);
const SalesPolicyCreateWithStepper = Loadable(
  lazy(() => import("../components/sales/policies/policy-generic/PolicyCreateWithStepper.jsx"))
);
const SalesPolicyCreateNewWithStepper = Loadable(
  lazy(() => import("../components/sales/policies/policy-create/SalesPolicyCreateNewWithStepper.jsx"))
);

const BulkPolicyUpload = Loadable(
  lazy(() => import("../components/sales/policies/policy-create/bulk-upload-policy"))
);
const EditTargetAllotment = Loadable(
  lazy(() => import("../components/reports/sales/edit-target-allotment.jsx"))
);
const CompanyUsers = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/companies/company-users")
  )
);
const DealershipUsers = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/partnerships/dealership-users")
  )
);
const BulkUploadDealership = Loadable(
  lazy(() =>
    import("../components/affiliations/clients/partnerships/modals/bulk-upload-dealerships")
  )
);
const Helpdesk = Loadable(
  lazy(() => import("../components/documents/helpdesk"))
);
const KYC = Loadable(lazy(() => import("../components/documents/kyc/kyc")));
const Viewhelpdesk = Loadable(
  lazy(() => import("../components/documents/view-helpdesk.jsx"))
);
const ELearningCourses = Loadable(
  lazy(() => import("../components/training/e-learning/operations/courses"))
);
const ELearningCourseSections = Loadable(
  lazy(() => import("../components/training/e-learning/operations/sections"))
);
const ELearningPlay = Loadable(
  lazy(() => import("../components/training/e-learning/operations/play"))
);
const ELearningQuiz = Loadable(
  lazy(() => import("../components/training/e-learning/operations/quiz"))
);
const ECourseModule = Loadable(
  lazy(() => import("../components/training/e-learning/operations/courses_module"))
);
const ECourseModuleTopic = Loadable(
  lazy(() => import("../components/training/e-learning/operations/courses-topic"))
);
const ECourseModuleQuiz = Loadable(
  lazy(() => import("../components/training/e-learning/operations/courses-quiz.jsx"))
);
const ManageCourse = Loadable(
  lazy(() => import("../components/training/e-learning/manage/manage-course"))
);
const ManageCourseSections = Loadable(
  lazy(() => import("../components/training/e-learning/manage/manage-section"))
);
const MyRequests = Loadable(
  lazy(() => import("../components/requests/my-requests"))
);
const CashifyMyRequests = Loadable(
  lazy(() => import("../components/requests/cashify-my-request"))
);
const AdminRequests = Loadable(
  lazy(() => import("../components/requests/admin-requests"))
);
const RequestsForMe = Loadable(
  lazy(() => import("../components/requests/requests-for-me"))
);
const CashifyAllRequest = Loadable(
  lazy(() => import("../components/requests/all-cashify-request"))
);
const CashifyRequestsForMe = Loadable(
  lazy(() => import("../components/requests/cashify-request-for-me"))
);
const UploadImageToS3 = Loadable(
  lazy(() => import("../components/requests/upload-image-to-s3"))
);
const WalletCredits = Loadable(
  lazy(() => import("../components/wallet/user/credits"))
);
// const LoginWithBgImage = Loadable(lazy(() => import('../pages/authentication/loginWithBgImage')));
const DMSData = Loadable(
  lazy(() => import("../components/affiliations/clients/dms_data/dms_data"))
);
const DMSList = Loadable(
  lazy(() => import("../components/affiliations/clients/dms_data/dms_list"))
);
const UserWalletStatement = Loadable(
  lazy(() => import("../components/wallet/user/statement"))
);
const Countries = Loadable(
  lazy(() => import("../components/sales/taxes/countries/countries"))
);
const States = Loadable(
  lazy(() => import("../components/sales/taxes/states/states"))
);
const ParentTaxes = Loadable(
  lazy(() => import("../components/sales/taxes/parent-taxes/parent-taxes"))
);
const SubTaxes = Loadable(
  lazy(() => import("../components/sales/taxes/sub-taxes/sub-taxes"))
);
const BdmSalesReport = Loadable(
  lazy(() => import("../components/reports/Bdm-sales/sales-report"))
);
const BdmTable = Loadable(
  lazy(() => import("../components/reports/Bdm-sales/Bdm-table"))
);
const BdmPolicies = Loadable(
  lazy(() => import("../components/sales/bdm/bdm-product"))
);
const ProductLists = Loadable(
  lazy(() => import("../components/sales/bdm/product-List"))
);
const AddUser = Loadable(
  lazy(() => import("../components/user_management/users/AddUser"))
);

// Email
const Email = Loadable(
  lazy(() => import("../components/application/email-app/emailDefault"))
);

// Chat
const Chat = Loadable(lazy(() => import("../components/application/chat-app")));

// Bookmark
const Bookmark = Loadable(
  lazy(() => import("../components/application/bookmark"))
);

// Project app
const ProjectList = Loadable(
  lazy(() => import("../components/application/project/project"))
);
const NewProject = Loadable(
  lazy(() => import("../components/application/project/new-project"))
);

// File Manager App
const FileManager = Loadable(
  lazy(() => import("../components/application/file-manager/file-manager"))
);

// Kanban Board
const kanbanBoard = Loadable(
  lazy(() => import("../components/application/kanban-board/kanbanBoard"))
);

// Task
const TaskApp = Loadable(
  lazy(() => import("../components/application/task-app"))
);

// Contact app
const ContactApp = Loadable(
  lazy(() => import("../components/application/contact-app"))
);

// todo-app
const Todo = Loadable(lazy(() => import("../components/application/todo-app")));

// todo-firebase-app
const TodoFirebase = Loadable(
  lazy(() => import("../components/application/todo-firebase-app"))
);

// Session
const Session = Loadable(lazy(() => import("../components/user_management/session")));
const AutomatedEmail = Loadable(lazy(() => import("../components/user_management/automated_email")));
const VisitingReport = Loadable(lazy(() => import("../components/visiting/Visiting.jsx")));

const IndiaMap = Loadable(
  lazy(() => import("../components/required-charts/indiaMapChart/india-map-chart"))
);

const GetOtp = Loadable(lazy(() => import("../components/user_management/getOtp")));

export default ApplicationRoutes;
